import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableNonPharmaItemFragment = { readonly __typename?: 'SyncableNonPharmaItem', readonly id: string, readonly title: string, readonly brand?: string | null, readonly categoryId: string, readonly snomedId?: string | null, readonly keywords: ReadonlyArray<string>, readonly productType: Types.ProductType, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncNonPharmaItemPullQueryVariables = Types.Exact<{
  input: Types.PullNonPharmaItemInput;
}>;


export type SyncNonPharmaItemPullQuery = { readonly __typename?: 'Query', readonly pullNonPharmaItem: { readonly __typename?: 'PullNonPharmaItemResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableNonPharmaItem', readonly id: string, readonly title: string, readonly brand?: string | null, readonly categoryId: string, readonly snomedId?: string | null, readonly keywords: ReadonlyArray<string>, readonly productType: Types.ProductType, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableNonPharmaItemFragmentDoc = gql`
    fragment WholeSyncableNonPharmaItem on SyncableNonPharmaItem {
  id
  title
  brand
  categoryId
  snomedId
  keywords
  productType
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncNonPharmaItemPullDocument = gql`
    query SyncNonPharmaItemPull($input: PullNonPharmaItemInput!) {
  pullNonPharmaItem(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableNonPharmaItem
    }
  }
}
    ${WholeSyncableNonPharmaItemFragmentDoc}`;

/**
 * __useSyncNonPharmaItemPullQuery__
 *
 * To run a query within a React component, call `useSyncNonPharmaItemPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncNonPharmaItemPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncNonPharmaItemPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncNonPharmaItemPullQuery(baseOptions: Apollo.QueryHookOptions<SyncNonPharmaItemPullQuery, SyncNonPharmaItemPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncNonPharmaItemPullQuery, SyncNonPharmaItemPullQueryVariables>(SyncNonPharmaItemPullDocument, options);
      }
export function useSyncNonPharmaItemPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncNonPharmaItemPullQuery, SyncNonPharmaItemPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncNonPharmaItemPullQuery, SyncNonPharmaItemPullQueryVariables>(SyncNonPharmaItemPullDocument, options);
        }
export type SyncNonPharmaItemPullQueryHookResult = ReturnType<typeof useSyncNonPharmaItemPullQuery>;
export type SyncNonPharmaItemPullLazyQueryHookResult = ReturnType<typeof useSyncNonPharmaItemPullLazyQuery>;
export type SyncNonPharmaItemPullQueryResult = Apollo.QueryResult<SyncNonPharmaItemPullQuery, SyncNonPharmaItemPullQueryVariables>;